import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetOpenThreads as GetOpenThreadsQuery,
    GetOpenThreadsVariables as GetOpenThreadsQueryVariables,
    EventFragmentSparse,
} from 'nutshell-graphql-types';

import GET_OPEN_THREAD from '../queries/get-open-threads.graphql';

export function useGetOpenThread(id: string): {
    openThread: EventFragmentSparse | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, loading, refetch} = useQuery<
        GetOpenThreadsQuery,
        GetOpenThreadsQueryVariables
    >(GET_OPEN_THREAD, {
        variables: {id},
        fetchPolicy: 'cache-and-network',
    });

    const openThreads = data ? data.openThreads : null;

    return {
        openThread: openThreads ? openThreads[0] : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
